<template>
  <main>
    <section v-if="!croppedImage">
      <input
        v-if="needChangeFile"
        label="Imagem"
        type="file"
        @change="onFileChange"
        accept="image/png, image/jpeg"
        style="width: 100%; margin-bottom: 16px;"
      />
      <template v-if="uploadedImage != null">
        <cropper
          ref="cropper"
          class="cropper"
          :src="uploadedImage"
          :stencil-component="$options.components.CircleStencil"
        />
        <LUUIButtonPrimary
          class="Restyle"
          @click="crop"
          :ButtonText="$t('components.image_cropper.buttons.apply')"
        />
      </template>
    </section>

    <section v-if="croppedImage">
      <div style="text-align: center">
        <div>Raw Image:</div>
        <img :src="croppedImage" class="image-preview" />

        <div>Compressed Image:</div>
        <img :src="compressedImage" class="image-preview" />
      </div>

      <button
        @click="
          croppedImage = null;
          compressedImage = null;
        "
      >
        Cancel
      </button>
    </section>
  </main>
</template>

<script>
import { resizeDataUrlImage } from "./../helpers/image.helper.js";
import { Cropper, CircleStencil } from "vue-advanced-cropper";
import LUUIButtonPrimary from "@/components/LevelUpUI/Buttons/primary";
import "vue-advanced-cropper/dist/style.css";

export default {
  props: {
    getResult: {
      type: Function,
      default: () => {},
    },
    fileDataUrl: {
      type: String,
      default: null,
    },
    needChangeFile: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Cropper,
    CircleStencil,
    LUUIButtonPrimary,
  },
  data() {
    return {
      croppedImage: null,
      compressedImage: null,
      uploadedImage: this.fileDataUrl
    };
  },
  methods: {
    async crop() {
      const { coordinates, canvas } = this.$refs.cropper.getResult();
      this.coordinates = coordinates;

      if (canvas) {
        // this.croppedImage = canvas.toDataURL();
        this.compressedImage = await resizeDataUrlImage({
          dataUrl: canvas.toDataURL(),
          width: 256,
          height: 256,
        });

        this.getResult(this.compressedImage);
      }
    },
    onFileChange(event) {
      const input = event.target;
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadedImage = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
  },
};
</script>

<style scoped>
.cropper {
  height: 250px;
  width: 250px;
  background: #ddd;
  margin: 0% auto;
  margin-bottom: 16px;
}
.image-preview {
  display: inline-block;
  border-radius: 50%;
  width: 300px;
  height: 300px;
}

button {
  display: block;
}

.Restyle {
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 16px;
  border-radius: 8px;
}
.Restyle:deep(.TText) {
  margin: auto;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
}
</style>
